module.exports = __webpack_public_path__ + "static/pro-2339bedb773af64257735db1b718598e.jpg";